export default {
  /**
   *  @type {string} 検索画面
   */
  search: '/admin/company/',
  /**
   * 参照画面
   * @param {string} id TagID
   */
  refer: (id) => {
    return `/admin/company/refer/${id}`;
  },
  /**
   * @type {string} 新規作成画面
   */
  newEdit: '/admin/company/edit/',
  /**
   * 編集画面
   * @param {string} id TagID
   */
  edit: (id) => {
    return `/admin/company/edit/${id}`;
  },
};
